import { useCallback, useState } from "react";

import { cloneDateRange } from "../utils/cloneDateRange";

import type { CompleteDateRange } from "@/components/StructuredSearch/stores/structured-search/structured-search-store";

export const useDateRangeZoomHistory = () => {
  const [localDateRangeOverride, setLocalDateRangeOverride] = useState<
    CompleteDateRange | undefined
  >();
  const [localDateRangeHistory, setLocalDateRangeHistory] = useState<CompleteDateRange[]>([]);

  const canResetZoom = localDateRangeHistory.length > 0;

  const selectDateRangeFromChart = useCallback(
    (range: { from: Date; to: Date }, structuredDateRange: CompleteDateRange) => {
      const nextRange = { from: new Date(range.from), to: new Date(range.to) };
      const previousRange = cloneDateRange(structuredDateRange);
      setLocalDateRangeHistory(previousHistory => [...previousHistory, previousRange]);
      setLocalDateRangeOverride(nextRange);
    },
    [],
  );

  const resetDateRangeFromChart = useCallback(() => {
    setLocalDateRangeHistory(previousHistory => {
      const previousRange = previousHistory[previousHistory.length - 1];
      if (!previousRange) {
        return previousHistory;
      }
      const nextHistory = previousHistory.slice(0, -1);
      setLocalDateRangeOverride(nextHistory.length === 0 ? undefined : previousRange);
      return nextHistory;
    });
  }, []);

  return {
    canResetZoom,
    localDateRangeOverride,
    resetDateRangeFromChart,
    selectDateRangeFromChart,
  };
};
